import QueryString from 'query-string';
import { toastr } from "react-redux-toastr";
import { ACCESS_POINT_ENDPOINT } from "../../config/endpoints";
import { DEFAULT_DELETE_CONFIG, DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG, DEFAULT_PUT_CONFIG } from "../../config/rest";
import { isErrorResponse } from "../../utils/error-handlers";
import {
  CLEAR_ENDPOINT,
  CLEAR_ENDPOINTS,
  FLAG_ENDPOINT_ENDPOINT,
  FLAG_GETTING_ENDPOINTS,
  GET_ENDPOINT,
  GET_ENDPOINTS,
} from '../types/security/Endpoint';
import { ENDPOINT_PATH } from '../../config/paths';
import { push } from 'react-router-redux';

const flagGettingEndpoints = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_ENDPOINTS,
    payload: flag,
  });

const getEndpoints = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingEndpoints(true));
    const query = tableFilters;
    const url = `${ACCESS_POINT_ENDPOINT}?${QueryString.stringify(query)}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise, null, dispatch);
    const response = await promise.json();
    dispatch({
      type: GET_ENDPOINTS,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingEndpoints(false));
  }
}

const clearEndpoints = () => (dispatch) =>
  dispatch({
    type: CLEAR_ENDPOINTS,
  });

  const flagEndpointEndpoint = (flag) => (dispatch) =>
    dispatch({
      type: FLAG_ENDPOINT_ENDPOINT,
      payload: flag,
    });
  
  const getEndpoint =
    async ({ endpointId }) =>
    async (dispatch) => {
      try {
        dispatch(flagEndpointEndpoint(true));
        const url = `${ACCESS_POINT_ENDPOINT}/${endpointId}`;
        const promise = await fetch(url, DEFAULT_GET_CONFIG);
        await isErrorResponse(promise, null, dispatch);
        const response = await promise.json();
        dispatch({
          type: GET_ENDPOINT,
          payload: response,
        });
      } catch ({ message }) {
        toastr.error('Error', message);
      } finally {
        dispatch(flagEndpointEndpoint(false));
      }
    };
  
  const clearEndpoint = () => (dispatch) =>
    dispatch({
      type: CLEAR_ENDPOINT,
    });

  const createNewEndpoint = async ({
  name,
      description,
      route,
      permissionType
}) => {
  const payload = {
    name,
      description,
      route,
      permissionType
  };
  const url = ACCESS_POINT_ENDPOINT;
  const promise = await fetch(url, {
    ...DEFAULT_POST_CONFIG,
    body: JSON.stringify(payload),
  });
  await isErrorResponse(promise);
  const endpoint = await promise.json();
  return endpoint;
};

  const postEndpoint =
    async ({
      name,
      description,
      route,
      permissionType
    }) =>
    async (dispatch) => {
      try {
        dispatch(flagEndpointEndpoint(true));
        const response = await createNewEndpoint({
          name,
          description,
          route,
          permissionType
        });
        if (response) {
          dispatch(push(`${ENDPOINT_PATH}/${response.id}`));
        }
      } catch ({ message }) {
        toastr.error('Error', message);
      } finally {
        dispatch(flagEndpointEndpoint(false));
      }
    };

    const putEndpoint =
  async (
    endpointId,
    {
      name,
      description,
      route,
      permissionType
    },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagEndpointEndpoint(true));
      const payload = {
        id: endpointId,
        name,
      description,
      route,
      permissionType
      };
      const url = `${ACCESS_POINT_ENDPOINT}/${endpointId}`;
      const promise = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(`${ENDPOINT_PATH}/${endpointId}`));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagEndpointEndpoint(false));
    }
  };

  const deleteEndpoint =
  async ({ endpointId }) =>
  async (dispatch) => {
    try {
      dispatch(flagEndpointEndpoint(true));
      const url = `${ACCESS_POINT_ENDPOINT}/${endpointId}`;
      const promise = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(ENDPOINT_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagEndpointEndpoint(false));
    }
  };

export {
  clearEndpoints,
  getEndpoints,
  getEndpoint,
  clearEndpoint,
  postEndpoint,
  deleteEndpoint,
  putEndpoint
};
